/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as ShopRouteImport } from './routes/_shop'
import { Route as LoginRouteImport } from './routes/login'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as AuthAdminRouteImport } from './routes/_auth/admin'
import { Route as AuthVerkaufRouteImport } from './routes/_auth/verkauf'
import { Route as ShopIndexRouteImport } from './routes/_shop/index'
import { Route as ShopCartRouteImport } from './routes/_shop/cart'
import { Route as ShopCheckoutRouteImport } from './routes/_shop/checkout'
import { Route as ShopNewsRouteImport } from './routes/_shop/news'
import { Route as AuthAdminIndexRouteImport } from './routes/_auth/admin/index'
import { Route as AuthAdminCategoriesRouteImport } from './routes/_auth/admin/categories'
import { Route as AuthAdminItemsRouteImport } from './routes/_auth/admin/items'
import { Route as AuthAdminRechtlichesRouteImport } from './routes/_auth/admin/rechtliches'
import { Route as AuthAdminStaffRouteImport } from './routes/_auth/admin/staff'
import { Route as AuthAdminStatistikRouteImport } from './routes/_auth/admin/statistik'
import { Route as AuthAdminTermineRouteImport } from './routes/_auth/admin/termine'
import { Route as AuthVerkaufIndexRouteImport } from './routes/_auth/verkauf/index'
import { Route as AuthVerkaufPasskeysRouteImport } from './routes/_auth/verkauf/passkeys'
import { Route as AuthVerkaufScanRouteImport } from './routes/_auth/verkauf/scan'
import { Route as ShopOrderPickupCodeRouteImport } from './routes/_shop/order.$pickupCode'
import { Route as AuthAdminPostsIndexRouteImport } from './routes/_auth/admin/posts/index'
import { Route as AuthAdminPostsUuidRouteImport } from './routes/_auth/admin/posts/$uuid'
import { Route as AuthVerkaufBeschaffungDateRouteImport } from './routes/_auth/verkauf/beschaffung.$date'
import { Route as AuthVerkaufOrderOrderIdRouteImport } from './routes/_auth/verkauf/order.$orderId'
import { Route as AuthVerkaufTagesabschlussDateRouteImport } from './routes/_auth/verkauf/tagesabschluss.$date'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const ShopRoute = ShopRouteImport.update({
  id: '/_shop',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAdminRoute = AuthAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVerkaufRoute = AuthVerkaufRouteImport.update({
  id: '/verkauf',
  path: '/verkauf',
  getParentRoute: () => AuthRoute,
} as any)
const ShopIndexRoute = ShopIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ShopRoute,
} as any)
const ShopCartRoute = ShopCartRouteImport.update({
  id: '/cart',
  path: '/cart',
  getParentRoute: () => ShopRoute,
} as any)
const ShopCheckoutRoute = ShopCheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => ShopRoute,
} as any)
const ShopNewsRoute = ShopNewsRouteImport.update({
  id: '/news',
  path: '/news',
  getParentRoute: () => ShopRoute,
} as any)
const AuthAdminIndexRoute = AuthAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminCategoriesRoute = AuthAdminCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminItemsRoute = AuthAdminItemsRouteImport.update({
  id: '/items',
  path: '/items',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminRechtlichesRoute = AuthAdminRechtlichesRouteImport.update({
  id: '/rechtliches',
  path: '/rechtliches',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminStaffRoute = AuthAdminStaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminStatistikRoute = AuthAdminStatistikRouteImport.update({
  id: '/statistik',
  path: '/statistik',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminTermineRoute = AuthAdminTermineRouteImport.update({
  id: '/termine',
  path: '/termine',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthVerkaufIndexRoute = AuthVerkaufIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthVerkaufRoute,
} as any)
const AuthVerkaufPasskeysRoute = AuthVerkaufPasskeysRouteImport.update({
  id: '/passkeys',
  path: '/passkeys',
  getParentRoute: () => AuthVerkaufRoute,
} as any)
const AuthVerkaufScanRoute = AuthVerkaufScanRouteImport.update({
  id: '/scan',
  path: '/scan',
  getParentRoute: () => AuthVerkaufRoute,
} as any)
const ShopOrderPickupCodeRoute = ShopOrderPickupCodeRouteImport.update({
  id: '/order/$pickupCode',
  path: '/order/$pickupCode',
  getParentRoute: () => ShopRoute,
} as any)
const AuthAdminPostsIndexRoute = AuthAdminPostsIndexRouteImport.update({
  id: '/posts/',
  path: '/posts/',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminPostsUuidRoute = AuthAdminPostsUuidRouteImport.update({
  id: '/posts/$uuid',
  path: '/posts/$uuid',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthVerkaufBeschaffungDateRoute =
  AuthVerkaufBeschaffungDateRouteImport.update({
    id: '/beschaffung/$date',
    path: '/beschaffung/$date',
    getParentRoute: () => AuthVerkaufRoute,
  } as any)
const AuthVerkaufOrderOrderIdRoute = AuthVerkaufOrderOrderIdRouteImport.update({
  id: '/order/$orderId',
  path: '/order/$orderId',
  getParentRoute: () => AuthVerkaufRoute,
} as any)
const AuthVerkaufTagesabschlussDateRoute =
  AuthVerkaufTagesabschlussDateRouteImport.update({
    id: '/tagesabschluss/$date',
    path: '/tagesabschluss/$date',
    getParentRoute: () => AuthVerkaufRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof ShopIndexRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/admin': typeof AuthAdminRouteWithChildren
  '/verkauf': typeof AuthVerkaufRouteWithChildren
  '/cart': typeof ShopCartRoute
  '/checkout': typeof ShopCheckoutRoute
  '/news': typeof ShopNewsRoute
  '/admin/categories': typeof AuthAdminCategoriesRoute
  '/admin/items': typeof AuthAdminItemsRoute
  '/admin/rechtliches': typeof AuthAdminRechtlichesRoute
  '/admin/staff': typeof AuthAdminStaffRoute
  '/admin/statistik': typeof AuthAdminStatistikRoute
  '/admin/termine': typeof AuthAdminTermineRoute
  '/verkauf/passkeys': typeof AuthVerkaufPasskeysRoute
  '/verkauf/scan': typeof AuthVerkaufScanRoute
  '/order/$pickupCode': typeof ShopOrderPickupCodeRoute
  '/admin/': typeof AuthAdminIndexRoute
  '/verkauf/': typeof AuthVerkaufIndexRoute
  '/admin/posts/$uuid': typeof AuthAdminPostsUuidRoute
  '/verkauf/beschaffung/$date': typeof AuthVerkaufBeschaffungDateRoute
  '/verkauf/order/$orderId': typeof AuthVerkaufOrderOrderIdRoute
  '/verkauf/tagesabschluss/$date': typeof AuthVerkaufTagesabschlussDateRoute
  '/admin/posts/': typeof AuthAdminPostsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof ShopIndexRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/cart': typeof ShopCartRoute
  '/checkout': typeof ShopCheckoutRoute
  '/news': typeof ShopNewsRoute
  '/admin/categories': typeof AuthAdminCategoriesRoute
  '/admin/items': typeof AuthAdminItemsRoute
  '/admin/rechtliches': typeof AuthAdminRechtlichesRoute
  '/admin/staff': typeof AuthAdminStaffRoute
  '/admin/statistik': typeof AuthAdminStatistikRoute
  '/admin/termine': typeof AuthAdminTermineRoute
  '/verkauf/passkeys': typeof AuthVerkaufPasskeysRoute
  '/verkauf/scan': typeof AuthVerkaufScanRoute
  '/order/$pickupCode': typeof ShopOrderPickupCodeRoute
  '/admin': typeof AuthAdminIndexRoute
  '/verkauf': typeof AuthVerkaufIndexRoute
  '/admin/posts/$uuid': typeof AuthAdminPostsUuidRoute
  '/verkauf/beschaffung/$date': typeof AuthVerkaufBeschaffungDateRoute
  '/verkauf/order/$orderId': typeof AuthVerkaufOrderOrderIdRoute
  '/verkauf/tagesabschluss/$date': typeof AuthVerkaufTagesabschlussDateRoute
  '/admin/posts': typeof AuthAdminPostsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_shop': typeof ShopRouteWithChildren
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/_auth/admin': typeof AuthAdminRouteWithChildren
  '/_auth/verkauf': typeof AuthVerkaufRouteWithChildren
  '/_shop/cart': typeof ShopCartRoute
  '/_shop/checkout': typeof ShopCheckoutRoute
  '/_shop/news': typeof ShopNewsRoute
  '/_shop/': typeof ShopIndexRoute
  '/_auth/admin/categories': typeof AuthAdminCategoriesRoute
  '/_auth/admin/items': typeof AuthAdminItemsRoute
  '/_auth/admin/rechtliches': typeof AuthAdminRechtlichesRoute
  '/_auth/admin/staff': typeof AuthAdminStaffRoute
  '/_auth/admin/statistik': typeof AuthAdminStatistikRoute
  '/_auth/admin/termine': typeof AuthAdminTermineRoute
  '/_auth/verkauf/passkeys': typeof AuthVerkaufPasskeysRoute
  '/_auth/verkauf/scan': typeof AuthVerkaufScanRoute
  '/_shop/order/$pickupCode': typeof ShopOrderPickupCodeRoute
  '/_auth/admin/': typeof AuthAdminIndexRoute
  '/_auth/verkauf/': typeof AuthVerkaufIndexRoute
  '/_auth/admin/posts/$uuid': typeof AuthAdminPostsUuidRoute
  '/_auth/verkauf/beschaffung/$date': typeof AuthVerkaufBeschaffungDateRoute
  '/_auth/verkauf/order/$orderId': typeof AuthVerkaufOrderOrderIdRoute
  '/_auth/verkauf/tagesabschluss/$date': typeof AuthVerkaufTagesabschlussDateRoute
  '/_auth/admin/posts/': typeof AuthAdminPostsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/register'
    | '/admin'
    | '/verkauf'
    | '/cart'
    | '/checkout'
    | '/news'
    | '/admin/categories'
    | '/admin/items'
    | '/admin/rechtliches'
    | '/admin/staff'
    | '/admin/statistik'
    | '/admin/termine'
    | '/verkauf/passkeys'
    | '/verkauf/scan'
    | '/order/$pickupCode'
    | '/admin/'
    | '/verkauf/'
    | '/admin/posts/$uuid'
    | '/verkauf/beschaffung/$date'
    | '/verkauf/order/$orderId'
    | '/verkauf/tagesabschluss/$date'
    | '/admin/posts/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/register'
    | '/cart'
    | '/checkout'
    | '/news'
    | '/admin/categories'
    | '/admin/items'
    | '/admin/rechtliches'
    | '/admin/staff'
    | '/admin/statistik'
    | '/admin/termine'
    | '/verkauf/passkeys'
    | '/verkauf/scan'
    | '/order/$pickupCode'
    | '/admin'
    | '/verkauf'
    | '/admin/posts/$uuid'
    | '/verkauf/beschaffung/$date'
    | '/verkauf/order/$orderId'
    | '/verkauf/tagesabschluss/$date'
    | '/admin/posts'
  id:
    | '__root__'
    | '/_auth'
    | '/_shop'
    | '/login'
    | '/register'
    | '/_auth/admin'
    | '/_auth/verkauf'
    | '/_shop/cart'
    | '/_shop/checkout'
    | '/_shop/news'
    | '/_shop/'
    | '/_auth/admin/categories'
    | '/_auth/admin/items'
    | '/_auth/admin/rechtliches'
    | '/_auth/admin/staff'
    | '/_auth/admin/statistik'
    | '/_auth/admin/termine'
    | '/_auth/verkauf/passkeys'
    | '/_auth/verkauf/scan'
    | '/_shop/order/$pickupCode'
    | '/_auth/admin/'
    | '/_auth/verkauf/'
    | '/_auth/admin/posts/$uuid'
    | '/_auth/verkauf/beschaffung/$date'
    | '/_auth/verkauf/order/$orderId'
    | '/_auth/verkauf/tagesabschluss/$date'
    | '/_auth/admin/posts/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  ShopRoute: typeof ShopRouteWithChildren
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_shop': {
      id: '/_shop'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ShopRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/admin': {
      id: '/_auth/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthAdminRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/verkauf': {
      id: '/_auth/verkauf'
      path: '/verkauf'
      fullPath: '/verkauf'
      preLoaderRoute: typeof AuthVerkaufRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_shop/': {
      id: '/_shop/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ShopIndexRouteImport
      parentRoute: typeof ShopRoute
    }
    '/_shop/cart': {
      id: '/_shop/cart'
      path: '/cart'
      fullPath: '/cart'
      preLoaderRoute: typeof ShopCartRouteImport
      parentRoute: typeof ShopRoute
    }
    '/_shop/checkout': {
      id: '/_shop/checkout'
      path: '/checkout'
      fullPath: '/checkout'
      preLoaderRoute: typeof ShopCheckoutRouteImport
      parentRoute: typeof ShopRoute
    }
    '/_shop/news': {
      id: '/_shop/news'
      path: '/news'
      fullPath: '/news'
      preLoaderRoute: typeof ShopNewsRouteImport
      parentRoute: typeof ShopRoute
    }
    '/_auth/admin/': {
      id: '/_auth/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthAdminIndexRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/categories': {
      id: '/_auth/admin/categories'
      path: '/categories'
      fullPath: '/admin/categories'
      preLoaderRoute: typeof AuthAdminCategoriesRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/items': {
      id: '/_auth/admin/items'
      path: '/items'
      fullPath: '/admin/items'
      preLoaderRoute: typeof AuthAdminItemsRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/rechtliches': {
      id: '/_auth/admin/rechtliches'
      path: '/rechtliches'
      fullPath: '/admin/rechtliches'
      preLoaderRoute: typeof AuthAdminRechtlichesRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/staff': {
      id: '/_auth/admin/staff'
      path: '/staff'
      fullPath: '/admin/staff'
      preLoaderRoute: typeof AuthAdminStaffRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/statistik': {
      id: '/_auth/admin/statistik'
      path: '/statistik'
      fullPath: '/admin/statistik'
      preLoaderRoute: typeof AuthAdminStatistikRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/termine': {
      id: '/_auth/admin/termine'
      path: '/termine'
      fullPath: '/admin/termine'
      preLoaderRoute: typeof AuthAdminTermineRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/verkauf/': {
      id: '/_auth/verkauf/'
      path: '/'
      fullPath: '/verkauf/'
      preLoaderRoute: typeof AuthVerkaufIndexRouteImport
      parentRoute: typeof AuthVerkaufRoute
    }
    '/_auth/verkauf/passkeys': {
      id: '/_auth/verkauf/passkeys'
      path: '/passkeys'
      fullPath: '/verkauf/passkeys'
      preLoaderRoute: typeof AuthVerkaufPasskeysRouteImport
      parentRoute: typeof AuthVerkaufRoute
    }
    '/_auth/verkauf/scan': {
      id: '/_auth/verkauf/scan'
      path: '/scan'
      fullPath: '/verkauf/scan'
      preLoaderRoute: typeof AuthVerkaufScanRouteImport
      parentRoute: typeof AuthVerkaufRoute
    }
    '/_shop/order/$pickupCode': {
      id: '/_shop/order/$pickupCode'
      path: '/order/$pickupCode'
      fullPath: '/order/$pickupCode'
      preLoaderRoute: typeof ShopOrderPickupCodeRouteImport
      parentRoute: typeof ShopRoute
    }
    '/_auth/admin/posts/': {
      id: '/_auth/admin/posts/'
      path: '/posts'
      fullPath: '/admin/posts/'
      preLoaderRoute: typeof AuthAdminPostsIndexRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/posts/$uuid': {
      id: '/_auth/admin/posts/$uuid'
      path: '/posts/$uuid'
      fullPath: '/admin/posts/$uuid'
      preLoaderRoute: typeof AuthAdminPostsUuidRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/verkauf/beschaffung/$date': {
      id: '/_auth/verkauf/beschaffung/$date'
      path: '/beschaffung/$date'
      fullPath: '/verkauf/beschaffung/$date'
      preLoaderRoute: typeof AuthVerkaufBeschaffungDateRouteImport
      parentRoute: typeof AuthVerkaufRoute
    }
    '/_auth/verkauf/order/$orderId': {
      id: '/_auth/verkauf/order/$orderId'
      path: '/order/$orderId'
      fullPath: '/verkauf/order/$orderId'
      preLoaderRoute: typeof AuthVerkaufOrderOrderIdRouteImport
      parentRoute: typeof AuthVerkaufRoute
    }
    '/_auth/verkauf/tagesabschluss/$date': {
      id: '/_auth/verkauf/tagesabschluss/$date'
      path: '/tagesabschluss/$date'
      fullPath: '/verkauf/tagesabschluss/$date'
      preLoaderRoute: typeof AuthVerkaufTagesabschlussDateRouteImport
      parentRoute: typeof AuthVerkaufRoute
    }
  }
}

interface AuthAdminRouteChildren {
  AuthAdminCategoriesRoute: typeof AuthAdminCategoriesRoute
  AuthAdminItemsRoute: typeof AuthAdminItemsRoute
  AuthAdminRechtlichesRoute: typeof AuthAdminRechtlichesRoute
  AuthAdminStaffRoute: typeof AuthAdminStaffRoute
  AuthAdminStatistikRoute: typeof AuthAdminStatistikRoute
  AuthAdminTermineRoute: typeof AuthAdminTermineRoute
  AuthAdminIndexRoute: typeof AuthAdminIndexRoute
  AuthAdminPostsUuidRoute: typeof AuthAdminPostsUuidRoute
  AuthAdminPostsIndexRoute: typeof AuthAdminPostsIndexRoute
}

const AuthAdminRouteChildren: AuthAdminRouteChildren = {
  AuthAdminCategoriesRoute: AuthAdminCategoriesRoute,
  AuthAdminItemsRoute: AuthAdminItemsRoute,
  AuthAdminRechtlichesRoute: AuthAdminRechtlichesRoute,
  AuthAdminStaffRoute: AuthAdminStaffRoute,
  AuthAdminStatistikRoute: AuthAdminStatistikRoute,
  AuthAdminTermineRoute: AuthAdminTermineRoute,
  AuthAdminIndexRoute: AuthAdminIndexRoute,
  AuthAdminPostsUuidRoute: AuthAdminPostsUuidRoute,
  AuthAdminPostsIndexRoute: AuthAdminPostsIndexRoute,
}

const AuthAdminRouteWithChildren = AuthAdminRoute._addFileChildren(
  AuthAdminRouteChildren,
)

interface AuthVerkaufRouteChildren {
  AuthVerkaufPasskeysRoute: typeof AuthVerkaufPasskeysRoute
  AuthVerkaufScanRoute: typeof AuthVerkaufScanRoute
  AuthVerkaufIndexRoute: typeof AuthVerkaufIndexRoute
  AuthVerkaufBeschaffungDateRoute: typeof AuthVerkaufBeschaffungDateRoute
  AuthVerkaufOrderOrderIdRoute: typeof AuthVerkaufOrderOrderIdRoute
  AuthVerkaufTagesabschlussDateRoute: typeof AuthVerkaufTagesabschlussDateRoute
}

const AuthVerkaufRouteChildren: AuthVerkaufRouteChildren = {
  AuthVerkaufPasskeysRoute: AuthVerkaufPasskeysRoute,
  AuthVerkaufScanRoute: AuthVerkaufScanRoute,
  AuthVerkaufIndexRoute: AuthVerkaufIndexRoute,
  AuthVerkaufBeschaffungDateRoute: AuthVerkaufBeschaffungDateRoute,
  AuthVerkaufOrderOrderIdRoute: AuthVerkaufOrderOrderIdRoute,
  AuthVerkaufTagesabschlussDateRoute: AuthVerkaufTagesabschlussDateRoute,
}

const AuthVerkaufRouteWithChildren = AuthVerkaufRoute._addFileChildren(
  AuthVerkaufRouteChildren,
)

interface AuthRouteChildren {
  AuthAdminRoute: typeof AuthAdminRouteWithChildren
  AuthVerkaufRoute: typeof AuthVerkaufRouteWithChildren
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAdminRoute: AuthAdminRouteWithChildren,
  AuthVerkaufRoute: AuthVerkaufRouteWithChildren,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface ShopRouteChildren {
  ShopCartRoute: typeof ShopCartRoute
  ShopCheckoutRoute: typeof ShopCheckoutRoute
  ShopNewsRoute: typeof ShopNewsRoute
  ShopIndexRoute: typeof ShopIndexRoute
  ShopOrderPickupCodeRoute: typeof ShopOrderPickupCodeRoute
}

const ShopRouteChildren: ShopRouteChildren = {
  ShopCartRoute: ShopCartRoute,
  ShopCheckoutRoute: ShopCheckoutRoute,
  ShopNewsRoute: ShopNewsRoute,
  ShopIndexRoute: ShopIndexRoute,
  ShopOrderPickupCodeRoute: ShopOrderPickupCodeRoute,
}

const ShopRouteWithChildren = ShopRoute._addFileChildren(ShopRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  ShopRoute: ShopRouteWithChildren,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
